/* eslint-disable */
import settings from "../../../configs/settings";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useContext, useEffect, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import Message from "../../../project/utils/Message";
import BuscarCristalDialog from "./BuscarCristalDialog";
import { getPorcentajeDescuento } from "../../../project/services/ArticuloService";
import { formatMoney } from "../../utils/utils"

//
// ################################################################################
//
const AnteojoCristales = () => {
  const {
    anteojoCristalesTipoAnteojoOptions,
    initialAnteojoCristales,
    anteojoCristales,
    handleChangeAnteojoCristales,
    setAnteojoCristales,
    recetaLejos,
    recetaCerca,
    recetaIntermedia,
    anteojoTratamientosRows,
    setAnteojoTratamientosRows,
    totalCristales,
    totalCristalesContado,
    gaAction,
  } = useContext(GestionAtencionContext);

  let { lejosCheck } = recetaLejos;
  let { cercaCheck } = recetaCerca;
  let { intermediaCheck } = recetaIntermedia;

  let {
    anteojoCristalesTipoAnteojo,
    anteojoCristalesTipoAnteojoDisabled,
    anteojoCristalesSelectedCristalOD,
    anteojoCristalesDescripcionCristalOD,
    anteojoCristalesPrecioVentaCristalOD,
    // anteojoCristalesPrecioVentaOriginalCristalOD,
    // anteojoCristalesPorcentajeDescuentoCristalOD,
    anteojoCristalesPrecioVentaContadoCristalOD,
    anteojoCristalesSelectedCristalOI,
    anteojoCristalesDescripcionCristalOI,
    anteojoCristalesPrecioVentaCristalOI,
    // anteojoCristalesPrecioVentaOriginalCristalOI,
    // anteojoCristalesPorcentajeDescuentoCristalOI,
    anteojoCristalesPrecioVentaContadoCristalOI,
    anteojoCristalesDistanciaPupilarOD,
    anteojoCristalesDistanciaPupilarOI,
    anteojoCristalesAlturaPupilarOD,
    anteojoCristalesAlturaPupilarOI,
    anteojoCristalesAlturaParpadoInferiorOD,
    anteojoCristalesAlturaParpadoInferiorOI,
  } = anteojoCristales;

  const [disabledCristales, setDisabledCristales] = useState(true);
  const [tipoAnteojoValidOptions, setTipoAnteojoValidOptions] = useState(
    anteojoCristalesTipoAnteojoOptions
  );
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [ojo, setOjo] = useState("");
  const [esfera, setEsfera] = useState(0);
  const [cilindro, setCilindro] = useState(0);
  const [adicion, setAdicion] = useState(0);
  //
  // #####################################################################################################################
  // cuando el usuario marca/desmarca las correcciones de la receta preparo los tipos de anteojos
  // que el usuario podra elegir cuando registre un anteojo
  useEffect(() => {
    let _tipoAnteojoOptionsTmp = [];

    if (!lejosCheck && !cercaCheck && intermediaCheck) {
      _tipoAnteojoOptionsTmp = anteojoCristalesTipoAnteojoOptions.map((item) =>
        item.id === "monofocal-intermedia" ? item : null
      );
    } else if (!lejosCheck && cercaCheck && !intermediaCheck) {
      _tipoAnteojoOptionsTmp = anteojoCristalesTipoAnteojoOptions.map((item) =>
        item.id === "monofocal-cerca" || item.id === "ocupacional" ? item : null
      );
    } else if (!lejosCheck && cercaCheck && intermediaCheck) {
      _tipoAnteojoOptionsTmp = anteojoCristalesTipoAnteojoOptions.map((item) =>
        item.id === "monofocal-cerca" ||
          item.id === "monofocal-intermedia" ||
          item.id === "ocupacional"
          ? item
          : null
      );
    } else if (lejosCheck && !cercaCheck && !intermediaCheck) {
      _tipoAnteojoOptionsTmp = anteojoCristalesTipoAnteojoOptions.map((item) =>
        item.id === "monofocal-lejos" ? item : null
      );
    } else if (lejosCheck && !cercaCheck && intermediaCheck) {
      _tipoAnteojoOptionsTmp = anteojoCristalesTipoAnteojoOptions.map((item) =>
        item.id === "monofocal-lejos" || item.id === "monofocal-intermedia" ? item : null
      );
    } else if (lejosCheck && cercaCheck && !intermediaCheck) {
      _tipoAnteojoOptionsTmp = anteojoCristalesTipoAnteojoOptions.map((item) =>
        item.id === "monofocal-lejos" ||
          item.id === "monofocal-cerca" ||
          item.id === "bifocal" ||
          item.id === "multifocal" ||
          item.id === "ocupacional"
          ? item
          : null
      );
    } else if (lejosCheck && cercaCheck && intermediaCheck) {
      _tipoAnteojoOptionsTmp = anteojoCristalesTipoAnteojoOptions.map((item) => item);
    }

    _tipoAnteojoOptionsTmp = _tipoAnteojoOptionsTmp.filter(
      (anteojoCristalesTipoAnteojo) => anteojoCristalesTipoAnteojo !== null
    );
    setTipoAnteojoValidOptions(_tipoAnteojoOptionsTmp);

    if (_tipoAnteojoOptionsTmp.length === 0) {
      // si no hay receta de lejos, cerca o intermedia registradas
      setAnteojoCristales(initialAnteojoCristales);
      setDisabledCristales(true);
    } else {
      // si hay receta de lejos, cerca o intermedia registradas
      setDisabledCristales(false);
    }
  }, [
    lejosCheck,
    cercaCheck,
    intermediaCheck,
    anteojoCristalesTipoAnteojoOptions,
    initialAnteojoCristales,
    setAnteojoCristales,
  ]);
  //
  // #####################################################################################################################
  //
  const handleClickButtonCristal = (ojoClicked) => {
    setOjo(ojoClicked);

    if (ojoClicked === "OD") {
      // ojo derecho
      switch (anteojoCristalesTipoAnteojo) {
        case "monofocal-cerca":
          setEsfera(parseFloat(recetaCerca.cercaOdEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOdCilindro));
          setAdicion(0);
          break;
        case "monofocal-lejos":
          setEsfera(parseFloat(recetaLejos.lejosOdEsfera));
          setCilindro(parseFloat(recetaLejos.lejosOdCilindro));
          setAdicion(0);
          break;
        case "monofocal-intermedia":
          setEsfera(parseFloat(recetaIntermedia.intermediaOdEsfera));
          setCilindro(parseFloat(recetaIntermedia.intermediaOdCilindro));
          setAdicion(0);
          break;
        case "bifocal":
          setEsfera(parseFloat(recetaCerca.cercaOdEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOdCilindro));
          setAdicion(parseFloat(recetaCerca.cercaOdEsfera) - parseFloat(recetaLejos.lejosOdEsfera));
          break;
        case "multifocal":
          setEsfera(parseFloat(recetaCerca.cercaOdEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOdCilindro));
          setAdicion(parseFloat(recetaCerca.cercaOdEsfera) - parseFloat(recetaLejos.lejosOdEsfera));
          break;
        case "ocupacional":
          setEsfera(parseFloat(recetaCerca.cercaOdEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOdCilindro));
          setAdicion(0);
          break;
        default:
      }
    } else {
      // ojo izquierdo
      switch (anteojoCristalesTipoAnteojo) {
        case "monofocal-cerca":
          setEsfera(parseFloat(recetaCerca.cercaOiEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOiCilindro));
          setAdicion(0);
          break;
        case "monofocal-lejos":
          setEsfera(parseFloat(recetaLejos.lejosOiEsfera));
          setCilindro(parseFloat(recetaLejos.lejosOiCilindro));
          setAdicion(0);
          break;
        case "monofocal-intermedia":
          setEsfera(parseFloat(recetaIntermedia.intermediaOiEsfera));
          setCilindro(parseFloat(recetaIntermedia.intermediaOiCilindro));
          setAdicion(0);
          break;
        case "bifocal":
          setEsfera(parseFloat(recetaCerca.cercaOiEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOiCilindro));
          setAdicion(parseFloat(recetaCerca.cercaOiEsfera) - parseFloat(recetaLejos.lejosOiEsfera));
          break;
        case "multifocal":
          setEsfera(parseFloat(recetaCerca.cercaOiEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOiCilindro));
          setAdicion(parseFloat(recetaCerca.cercaOiEsfera) - parseFloat(recetaLejos.lejosOiEsfera));
          break;
        case "ocupacional":
          setEsfera(parseFloat(recetaCerca.cercaOiEsfera));
          setCilindro(parseFloat(recetaCerca.cercaOiCilindro));
          setAdicion(0);
          break;
        default:
      }
    }
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // #####################################################################################################################
  //
  const handleCloseBusquedaAvanzada = (articulo) => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // #####################################################################################################################
  //
  const handleSelectBusquedaAvanzada = async (articulo) => {
    setOpenDialogBusquedaAvanzada(false);

    let _params = {
      tipoArticulo: "cristal",
      id: articulo.id_cristal_producto,
    };
    const response = await getPorcentajeDescuento(_params);
    let _porcentajeDescuento = 0;
    if (response.ok) {
      _porcentajeDescuento = response.data.data.porcentaje_descuento;
    }
    let _precioVentaContado =
      articulo.precio_venta_lista - (articulo.precio_venta_lista * _porcentajeDescuento) / 100;
    let _cristalTmp = {};

    if (ojo === "OD") {
      _cristalTmp.anteojoCristalesTipoAnteojoDisabled = true;
      _cristalTmp.anteojoCristalesSelectedCristalOD = true;
      _cristalTmp.anteojoCristalesIdCristalProductoOD = articulo.id_cristal_producto;
      _cristalTmp.anteojoCristalesIdBLCrDiametroOD = articulo.id_bl_cr_diametro;
      _cristalTmp.anteojoCristalesIdBLCrAdicionOD = articulo.id_bl_cr_adicion;
      _cristalTmp.anteojoCristalesDescripcionCristalOD = articulo.descripcion_cristal_producto;
      _cristalTmp.anteojoCristalesPrecioVentaCristalOD = articulo.precio_venta_lista;
      _cristalTmp.anteojoCristalesPrecioVentaOriginalCristalOD = articulo.precio_venta_lista;
      _cristalTmp.anteojoCristalesPorcentajeDescuentoCristalOD = _porcentajeDescuento;
      _cristalTmp.anteojoCristalesPrecioVentaContadoCristalOD = _precioVentaContado;
      _cristalTmp.anteojoCristalesSolictaDatosMonturaClienteOD =
        articulo.solicita_datos_montura_cliente;
    } else {
      _cristalTmp.anteojoCristalesTipoAnteojoDisabled = true;
      _cristalTmp.anteojoCristalesSelectedCristalOI = true;
      _cristalTmp.anteojoCristalesIdCristalProductoOI = articulo.id_cristal_producto;
      _cristalTmp.anteojoCristalesIdBLCrDiametroOI = articulo.id_bl_cr_diametro;
      _cristalTmp.anteojoCristalesIdBLCrAdicionOI = articulo.id_bl_cr_adicion;
      _cristalTmp.anteojoCristalesDescripcionCristalOI = articulo.descripcion_cristal_producto;
      _cristalTmp.anteojoCristalesPrecioVentaCristalOI = articulo.precio_venta_lista;
      _cristalTmp.anteojoCristalesPrecioVentaOriginalCristalOI = articulo.precio_venta_lista;
      _cristalTmp.anteojoCristalesPorcentajeDescuentoCristalOI = _porcentajeDescuento;
      _cristalTmp.anteojoCristalesPrecioVentaContadoCristalOI = _precioVentaContado;
      _cristalTmp.anteojoCristalesSolictaDatosMonturaClienteOI =
        articulo.solicita_datos_montura_cliente;
    }
    setAnteojoCristales({ ...anteojoCristales, ..._cristalTmp });
  };
  //
  // #####################################################################################################################
  //
  const handleClickButtonLimpiar = (ojoClicked) => {
    let _cristalTmp = {};
    if (ojoClicked === "OD") {
      // si esta limpiando el cristal del OD
      _cristalTmp.anteojoCristalesTipoAnteojoDisabled =
        anteojoCristales.anteojoCristalesSelectedCristalOI ? true : false;
      _cristalTmp.anteojoCristalesSelectedCristalOD = false;
      _cristalTmp.anteojoCristalesDescripcionCristalOD = "";
      _cristalTmp.anteojoCristalesPrecioVentaCristalOD = 0;
      _cristalTmp.anteojoCristalesPrecioVentaOriginalCristalOD = 0;
      _cristalTmp.anteojoCristalesPorcentajeDescuentoCristalOD = 0;
      _cristalTmp.anteojoCristalesPrecioVentaContadoCristalOD = 0;
      _cristalTmp.anteojoCristalesSolictaDatosMonturaClienteOD = false;
      _cristalTmp.anteojoCristalesDistanciaPupilarOD = 0;
      _cristalTmp.anteojoCristalesAlturaPupilarOD = 0;
      _cristalTmp.anteojoCristalesAlturaParpadoInferiorOD = 0;
    } else {
      // si esta limpiando el cristal del OI
      _cristalTmp.anteojoCristalesTipoAnteojoDisabled =
        anteojoCristales.anteojoCristalesSelectedCristalOD ? true : false;
      _cristalTmp.anteojoCristalesSelectedCristalOI = false;
      _cristalTmp.anteojoCristalesDescripcionCristalOI = "";
      _cristalTmp.anteojoCristalesPrecioVentaCristalOI = 0;
      _cristalTmp.anteojoCristalesPrecioVentaOriginalCristalOI = 0;
      _cristalTmp.anteojoCristalesPorcentajeDescuentoCristalOI = 0;
      _cristalTmp.anteojoCristalesPrecioVentaContadoCristalOI = 0;
      _cristalTmp.anteojoCristalesSolictaDatosMonturaClienteOI = false;
      _cristalTmp.anteojoCristalesDistanciaPupilarOI = 0;
      _cristalTmp.anteojoCristalesAlturaPupilarOI = 0;
      _cristalTmp.anteojoCristalesAlturaParpadoInferiorOI = 0;
    }
    setAnteojoCristales({ ...anteojoCristales, ..._cristalTmp });

    if (anteojoTratamientosRows.length > 0) {
      let _anteojoTratamientosRowsTmp = anteojoTratamientosRows.filter(
        (item) => item.anteojoTratamientoOjo !== (ojoClicked === "OD" ? "derecho" : "izquierdo")
      );
      setAnteojoTratamientosRows(_anteojoTratamientosRowsTmp);
    }
  };
  //
  // #####################################################################################################################
  //
  return (
    <>
      <Box sx={{ mx: 1, px: 1, pb: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={10} md={6}>
            {/* select de tipo de anteojo */}
            <FormControl
              fullWidth
              disabled={disabledCristales}
              sx={{ mb: 1 }}
            >
              <InputLabel id="tipo-anteojo-select-label">Tipo de Anteojo</InputLabel>
              <Select
                labelId="tipo-anteojo-select-label"
                id="tipo-anteojo-select"
                name="anteojoCristalesTipoAnteojo"
                value={anteojoCristalesTipoAnteojo}
                label="Tipo de Anteojo"
                size="small"
                onChange={handleChangeAnteojoCristales}
                disabled={anteojoCristalesTipoAnteojoDisabled}
              >
                {tipoAnteojoValidOptions.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1}>

          {/* cristal ojo derecho */}

          <Grid item xs={12} md={6}>
            <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1 }}>
              <Typography
                component="div"
                gutterBottom
                align="left"
                sx={{ fontWeight: "bold", m: 0.5 }}
              >
                Ojo Derecho
              </Typography>

              {gaAction.cu !== "view" && (
                <>
                  {/* boton buscar cristal ojo derecho */}

                  <Button
                    sx={{ mt: 1, mr: 1, mb: 3 }}
                    variant="contained"
                    disabled={disabledCristales || anteojoCristalesTipoAnteojo === ""}
                    onClick={() => handleClickButtonCristal("OD")}
                    startIcon={<SavedSearchIcon />}
                  >
                    Buscar Cristal
                  </Button>

                  {/* boton limpiar cristal ojo derecho */}

                  <Button
                    sx={{ mt: 1, mr: 1, mb: 3 }}
                    variant="outlined"
                    disabled={disabledCristales || !anteojoCristalesSelectedCristalOD}
                    onClick={() => handleClickButtonLimpiar("OD")}
                    startIcon={<CleaningServicesIcon />}
                  >
                    Limpiar
                  </Button>
                </>
              )}

              {/* producto ojo derecho */}

              <TextField
                sx={{ width: "80%", mb: 2 }}
                id="descripcion-cristal-od"
                label="Producto"
                variant="outlined"
                size="small"
                name="anteojoCristalesDescripcionCristalOD"
                value={anteojoCristalesDescripcionCristalOD}
                disabled
              />

              {/* precio de venta ojo derecho */}

              <TextField
                sx={{ width: "20%", mb: 1, mr: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="precio-venta-cristal-od"
                label="Precio de lista"
                variant="outlined"
                size="small"
                name="anteojoCristalesPrecioVentaCristalOD"
                value={anteojoCristalesPrecioVentaCristalOD.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled
              />

              {/* precio de venta ojo derecho */}

              <TextField
                sx={{ width: "20%", mb: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="precio-venta-contado-cristal-od"
                label="Precio de contado"
                variant="outlined"
                size="small"
                name="anteojoCristalesPrecioVentaContadoCristalOD"
                value={anteojoCristalesPrecioVentaContadoCristalOD.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled
              />
            </Box>
          </Grid>

          {/* cristal ojo izquierdo */}
          <Grid item xs={12} md={6}>
            <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", p: 1 }}>
              <Typography
                component="div"
                gutterBottom
                align="left"
                sx={{ fontWeight: "bold", m: 0.5 }}
              >
                Ojo Izquierdo
              </Typography>

              {gaAction.cu !== "view" && (
                <>
                  {/* boton buscar cristal ojo izquierdo */}

                  <Button
                    sx={{ mt: 1, mr: 1, mb: 3 }}
                    variant="contained"
                    disabled={disabledCristales || anteojoCristalesTipoAnteojo === ""}
                    onClick={() => handleClickButtonCristal("OI")}
                    startIcon={<SavedSearchIcon />}
                  >
                    Buscar Cristal
                  </Button>

                  {/* boton limpiar cristal ojo izquierdo */}

                  <Button
                    sx={{ mt: 1, mr: 1, mb: 3 }}
                    variant="outlined"
                    disabled={disabledCristales || !anteojoCristalesSelectedCristalOI}
                    onClick={() => handleClickButtonLimpiar("OI")}
                    startIcon={<CleaningServicesIcon />}
                  >
                    Limpiar
                  </Button>
                </>
              )}

              {/* producto ojo izquierdo */}

              <TextField
                sx={{ width: "80%", mb: 2 }}
                id="descripcion-cristal-oi"
                label="Producto"
                variant="outlined"
                size="small"
                name="anteojoCristalesDescripcionCristalOI"
                value={anteojoCristalesDescripcionCristalOI}
                disabled
              />

              {/* precio de venta de lista ojo izquierdo */}

              <TextField
                sx={{ width: "20%", mb: 1, mr: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="precio-venta-cristal-oi"
                label="Precio de lista"
                variant="outlined"
                size="small"
                name="anteojoCristalesPrecioVentaCristalOI"
                value={anteojoCristalesPrecioVentaCristalOI.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled
              />

              {/* precio de venta de contado ojo izquierdo */}

              <TextField
                sx={{ width: "20%", mb: 1 }}
                inputProps={{ style: { textAlign: "right" } }}
                id="precio-venta-cristal-oi"
                label="Precio de contado"
                variant="outlined"
                size="small"
                name="anteojoCristalesPrecioVentaContadoCristalOI"
                value={anteojoCristalesPrecioVentaContadoCristalOI.toLocaleString(
                  settings.numericLocales.language,
                  settings.numericLocales.options
                )}
                disabled
              />
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            my: 1,
            p: 2,
            border: "1px solid LightGrey",
            borderRadius: "5px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item sm={2}></Grid>
            <Grid item sm={2}></Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="left">
                Distancia pupilar
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="left">
                Altura pupilar
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="left">
                Altura párpado inferior
              </Typography>
            </Grid>
            <Grid item sm={2}></Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item sm={2}></Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OD
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                id="distancia-pupilar-od"
                size="small"
                sx={{ width: "50%" }}
                inputProps={{ style: { textAlign: "center" } }}
                name="anteojoCristalesDistanciaPupilarOD"
                value={anteojoCristalesDistanciaPupilarOD}
                onChange={handleChangeAnteojoCristales}
                disabled={
                  gaAction.cu === "view" || disabledCristales || (!disabledCristales && !anteojoCristalesSelectedCristalOD)
                }
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                id="altura-pupilar-od"
                size="small"
                sx={{ width: "50%" }}
                inputProps={{ style: { textAlign: "center" } }}
                name="anteojoCristalesAlturaPupilarOD"
                value={anteojoCristalesAlturaPupilarOD}
                onChange={handleChangeAnteojoCristales}
                disabled={
                  gaAction.cu === "view" || disabledCristales || (!disabledCristales && !anteojoCristalesSelectedCristalOD)
                }
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                id="altura-parpado-inferior-od"
                size="small"
                sx={{ width: "50%" }}
                inputProps={{ style: { textAlign: "center" } }}
                name="anteojoCristalesAlturaParpadoInferiorOD"
                value={anteojoCristalesAlturaParpadoInferiorOD}
                onChange={handleChangeAnteojoCristales}
                disabled={
                  gaAction.cu === "view" || disabledCristales || (!disabledCristales && !anteojoCristalesSelectedCristalOD)
                }
              />
            </Grid>
            <Grid item sm={2}></Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item sm={2}></Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OI
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                id="distancia-pupilar-oi"
                size="small"
                sx={{ width: "50%" }}
                inputProps={{ style: { textAlign: "center" } }}
                name="anteojoCristalesDistanciaPupilarOI"
                value={anteojoCristalesDistanciaPupilarOI}
                onChange={handleChangeAnteojoCristales}
                disabled={
                  gaAction.cu === "view" || disabledCristales || (!disabledCristales && !anteojoCristalesSelectedCristalOI)
                }
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                id="altura-pupilar-oi"
                size="small"
                sx={{ width: "50%" }}
                inputProps={{ style: { textAlign: "center" } }}
                name="anteojoCristalesAlturaPupilarOI"
                value={anteojoCristalesAlturaPupilarOI}
                onChange={handleChangeAnteojoCristales}
                disabled={
                  gaAction.cu === "view" || disabledCristales || (!disabledCristales && !anteojoCristalesSelectedCristalOI)
                }
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                id="altura-parpado-inferior-oi"
                size="small"
                sx={{ width: "50%" }}
                inputProps={{ style: { textAlign: "center" } }}
                name="anteojoCristalesAlturaParpadoInferiorOI"
                value={anteojoCristalesAlturaParpadoInferiorOI}
                onChange={handleChangeAnteojoCristales}
                disabled={
                  gaAction.cu === "view" || disabledCristales || (!disabledCristales && !anteojoCristalesSelectedCristalOI)
                }
              />
            </Grid>
            <Grid item sm={2}></Grid>
          </Grid>
        </Box>

        <Grid container spacing={1}>
          <Grid item sm={6} sx={{ width: "100%" }}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE LISTA: {formatMoney(totalCristales)}
            </Typography>
          </Grid>

          <Grid item sm={6} sx={{ width: "100%" }}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE CONTADO: {formatMoney(totalCristalesContado)}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {openDialogBusquedaAvanzada && (
        <BuscarCristalDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
          anteojoCristalesTipoAnteojo={anteojoCristalesTipoAnteojo}
          esfera={esfera}
          cilindro={cilindro}
          adicion={adicion}
          ojo={ojo}
        />
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};

export default AnteojoCristales;
